import * as R from 'ramda'
import { v4 as uuidv4 } from 'uuid';

export const getUUID = () => R.toUpper(uuidv4())

export const tap = (v, str = '') => {
  console.log(v, str)
  return v
}
window.tap = tap